import { AgentExecutionContract } from '@terra/shared-contracts-agent-execution';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const agentExecutionClient = createTerraOrpcClient({
  contract: AgentExecutionContract,
  serviceName: SERVICE_NAME,
});
